const Tabs = {
  baseStyle: {},
  variants: {
    base: {
      root: {
        margin: "0",
        width: ["100vw", "100vw", "calc(100vw - 14em)"],
        display: "flex",
        flexDirection: "column",
        flexGrow: 1,
        minHeight: 0,
        padding: ["0em 1em 0em 1em", "0em 1em 0em 1em", "0em 2em 0em 2em"],
      },
      tabpanels: {
        borderStyle: "solid",
        borderColor: "Gray.300",
        borderWidth: "1px 0 0 0",
        padding: "0",
        flexGrow: 1,
        minHeight: 0,
      },
      tabpanel: {
        height: "100%",
        padding: [
          "0.25em 0em 0em 0em",
          "0.25em 0em 0em 0em",
          "0.5em 0em 0em 0em",
        ],
        overflow: "visible",
        display: "flex",
        flexDirection: "column",
        flexGrow: 1,
        minHeight: 0,
      },
      tab: {
        mr: "1em",
        height: "2.5em",
        padding: "1em 0em 1em 0em",
        flexShrink: 0,
        color: "Gray.500",
        bg: "Gray.100",
        fonts: "heading",
        borderStyle: "none",
        fontWeight: "100",
        textDecoration: "none",
        _hover: {
          color: "Gray.800",
          textDecoration: "none",
          borderStyle: "solid",
          borderColor: "Primary.300",
          borderWidth: "0 0 0.1em 0",
          _disabled: {
            textDecoration: "none",
          },
        },
        _disabled: {
          color: "Gray.300",
        },
        _selected: {
          color: "Gray.900",
          borderStyle: "solid",
          borderColor: "Primary.500",
          borderWidth: "0 0 0.1em 0",
        },
      },
    },
  },
}

export default Tabs
